// Returns date and time in local time zone
export const formatDateTime = (value) => {
  if (!value) return "";
  const safeValue = /\dZ$|\+\d{2}:\d{2}$/.test(value) ? value : value + "Z";
  const date = new Date(safeValue);
  if (isNaN(date)) return "";
  // Format as dd/MM/yyyy HH:mm:ss
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
};

// Returns only the Date (DD/MM/YYYY)
export const formatLocalDate = (value) => {
  if (!value) return "";
  const safeValue = /\dZ$|\+\d{2}:\d{2}$/.test(value) ? value : value + "Z";
  const date = new Date(safeValue);
  if (isNaN(date)) return "";
  // Format as dd/MM/yyyy
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Returns only the local time (HH:mm, 24-hour, localized)
export const formatLocalTime = (value) => {
  if (!value) return "";
  // If value does not end with Z or offset, treat as UTC
  const safeValue = /\dZ$|\+\d{2}:\d{2}$/.test(value) ? value : value + "Z";
  const date = new Date(safeValue);
  if (isNaN(date)) return "";
  return date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const isBeforeMinDate = (dateString) => {
  if (!dateString) return false; // handle empty/null input

  const minDate = new Date("1900-01-01");
  const inputDate = new Date(dateString);

  return inputDate < minDate;
};

export const isAfterToday = (dateString) => {
  if (!dateString) return false;

  // Parse user input as year, month, day (no timezone fuzz)
  const [year, month, day] = dateString.split("-").map(Number);
  const inputDate = new Date(year, month - 1, day);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // If input is strictly greater than today → future
  return inputDate.getTime() > today.getTime();
};
